<ng-container *ngIf="iconType == 'material'">
    <span class="material-symbols-rounded select-none" [class]='iconClass' translate="no">
        {{iconName}}
    </span>
</ng-container>
<ng-container *ngIf="iconType == 'mine'">
    <span class="mgIcon" [class]="iconClass + ' mgIcon-' + iconName" translate="no"></span>
    <!-- <span class="text-2xl w-fit h-fit " [class]="treasury.bgTipo_Solicitud.icon"></span> -->
</ng-container>